export default __webpack_public_path__ + "static/media/Lara.2af1601b.PNG";